import { LineItemStatus } from '../../../apis/graphql/types';

const POST_LAUNCH_LINE_ITEM_STATUSES = new Set<string>([
  LineItemStatus.Live,
  LineItemStatus.Delivered,
  LineItemStatus.Paused,
  LineItemStatus.Underdelivered,
  LineItemStatus.Suspended,
]);

const LAUNCH_EDIT_LINE_ITEM_STATUSES = new Set<string>([LineItemStatus.Ready, ...POST_LAUNCH_LINE_ITEM_STATUSES]);

export const isPostLaunchLineItemStatus = (status?: string | null): boolean => {
  if (!status) {
    return false;
  }

  return POST_LAUNCH_LINE_ITEM_STATUSES.has(status);
};

export const isLaunchEditLineItemStatus = (status?: string | null): boolean => {
  if (!status) {
    return false;
  }

  return LAUNCH_EDIT_LINE_ITEM_STATUSES.has(status);
};
